let brandConfig = null;
let brandConfigPromise = null;

function localeCandidates(locale) {
  const raw = String(locale || "").trim();
  if (!raw) {
    return ["default"];
  }
  const parts = raw.split(/[-_]/);
  const list = [raw];
  for (let i = parts.length - 1; i >= 1; i--) {
    list.push(parts.slice(0, i).join("-"));
  }
  if (parts[0] && list.indexOf(parts[0]) === -1) {
    list.push(parts[0]);
  }
  list.push("default");
  return list;
}

export function isChineseLocale(locale) {
  const value = String(locale || "").toLowerCase();
  return value.indexOf("zh") === 0 || value.indexOf("yue") === 0;
}

export function defaultBrandName(locale) {
  return isChineseLocale(locale) ? "维佳创" : "Cforbetter";
}

export function resolveBrandName(config, locale) {
  return resolveBrandText(config, "brand_name", locale, defaultBrandName(locale));
}

export function resolveBrandText(config, key, locale, fallback) {
  const value = config && config[key];
  if (value == null || value === "") {
    return fallback;
  }
  if (typeof value === "string") {
    return value;
  }
  const candidates = localeCandidates(locale);
  for (let i = 0; i < candidates.length; i++) {
    const text = value[candidates[i]];
    if (typeof text === "string" && text.trim() !== "") {
      return text;
    }
  }
  return fallback;
}

export function loadBrandConfig() {
  if (brandConfig) {
    return Promise.resolve(brandConfig);
  }
  if (!brandConfigPromise) {
    const base = process.env.BASE_URL || "/";
    const url = String(base).replace(/\/?$/, "/") + "brand.config.json";
    brandConfigPromise = fetch(url, { cache: "no-store" })
      .then(function (response) {
        return response.ok ? response.json() : {};
      })
      .then(function (data) {
        brandConfig = data && typeof data === "object" ? data : {};
        return brandConfig;
      })
      .catch(function () {
        brandConfig = {};
        return brandConfig;
      });
  }
  return brandConfigPromise;
}
